// utils/api.js
export const fetchEvents = async () => {
    try {
      const response = await fetch('https://backoffice.rohautism.org/events/api/events');
      const data = await response.json();
      return data.success ? data.data : [];
    } catch (error) {
      console.error('Error fetching events:', error);
      return [];
    }
  };
  
  export const fetchEventById = async (id) => {
    try {
      const response = await fetch(`https://backoffice.rohautism.org/events/api/events/${id}`);
      const data = await response.json();
      return data.success ? data.data : null;
    } catch (error) {
      console.error('Error fetching event:', error);
      return null;
    }
  };